import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

// textarea 
@Component({
    selector: 'textareas',
    template: `
      <div [formGroup]="form">
      <textarea [formControlName]="field.name" 
      [name]="field.name"
        rows="3" class="form-control"></textarea>

        <!-- <textarea  [formControlName]="field.name" [id]="field.name"
        rows="9" class="form-control"></textarea> -->

       
      </div> 
    `
})
export class TextAreaComponent {
    @Input() field:any = {};
    @Input() form:FormGroup;
    // get isValid() { return this.form.controls[this.field.name].valid; }
    // get isDirty() { return this.form.controls[this.field.name].dirty; }
  
    constructor() {
        //console.log(this.field);
        
    }
}


// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/offboarding/dynamic-form-builder/atoms/textarea.ts